"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ahooks_1 = require("ahooks");
var antd_1 = require("antd");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useConfig_1 = __importDefault(require("../_util/useConfig"));
var Link_1 = __importDefault(require("./Link"));
// 设计定义的栅格margin
var MARGIN_SIZE = 24;
// 设计定义的栅格为12，tea默认为24栅格
var GRID_COUNT = 24;
/**
 * 定义的合并单元格元素
 * @param props
 */
var CombineRow = function (props) {
    return react_1.default.createElement(react_1.default.Fragment, null, props.children);
};
/**
 * 根据指定的列数进行二维分割
 * @param children 单元格元素集合
 * @param col 指定的列数
 */
/*
function renderLayout(children: React.ReactNode, col: number) {
  const map = new Map();
  React.Children.forEach(children, (c, i) => {
    let target = 0;
    if (col && i >= col) {
      target = Math.floor(i / col);
    }
    const arr: Array<React.ReactNode> = map.get(target) || [];
    arr.push(c);
    map.set(target, arr);
  });
  const keys = Array.from(map.keys());

  const span = GRID_COUNT / col;
  return (
    <>
      {keys.map((k: number, i) => {
        const childrenArr: Array<React.ReactNode> = map.get(k);
        return (
          <Row key={`row-${i}`} gutter={[MARGIN_SIZE, MARGIN_SIZE]}>
            {childrenArr.map((c, ci) => (
              <Col key={`col-${i}-${ci}`} span={span}>
                {c}
              </Col>
            ))}
          </Row>
        );
      })}
    </>
  );
}
*/
var Section = function (props) {
    var style = props.style, className = props.className, children = props.children, _a = props.col, col = _a === void 0 ? 1 : _a;
    var _b = (0, useConfig_1.default)(), classPrefix = _b.classPrefix, mobileWidth = _b.mobileWidth;
    var ref = (0, react_1.useRef)(null);
    var size = (0, ahooks_1.useSize)(ref);
    var childrenCount = react_1.default.Children.count(children);
    /**
     * pc端部分布局主题
     * 基于tea实现，更换为antd后暂时弃用
     */
    /*
    function renderCombineLayout() {
      const arr = React.Children.toArray(children);
  
      let cIndex = -1; // CombineRow元素的位置
  
      React.Children.forEach(children, (c, i) => {
        if (c?.type === CombineRow) {
          cIndex = i;
          return;
        }
      });
  
      if (cIndex === -1) {
        return renderLayout(children, col);
      }
  
      const firtRowCount = col * 2 - 1; // 合并的单元格两行的元素综合
      const arrLeft = arr.slice(0, cIndex); // 出于合并单元格左侧的集合
      const arrCombine = arr.slice(cIndex, cIndex + 1); // 合并的单元格本身
      const arrRight = arr.slice(cIndex + 1, firtRowCount); // 出于合并单元格右侧的集合
      const arrRightExtends = arr.slice(firtRowCount); // 最后一行不包括合并的单元格
  
      const cSpan = GRID_COUNT / col; // 整体布局需要根据指定折行数进行均分，单个单元格的span
  
      const leftSpan = cSpan * (cIndex / 2);
      const rightSpan = GRID_COUNT - cSpan - leftSpan;
      return (
        <>
          <Row gutter={[MARGIN_SIZE, MARGIN_SIZE]}>
            <Col span={leftSpan}>{renderLayout(arrLeft, leftSpan / cSpan)}</Col>
  
            <Col span={cSpan}>{arrCombine[0]}</Col>
  
            <Col span={rightSpan}>{renderLayout(arrRight, rightSpan / cSpan)}</Col>
          </Row>
          {renderLayout(arrRightExtends, col)}
        </>
      );
    }
    */
    function renderAntd() {
        var cSpan = GRID_COUNT / col;
        return (react_1.default.createElement(antd_1.Row, { gutter: [MARGIN_SIZE, MARGIN_SIZE] }, react_1.default.Children.map(children, function (child) { return (react_1.default.createElement(antd_1.Col, { span: cSpan }, child)); })));
    }
    /**
     * 渲染pc端
     */
    function renderPC() {
        if (childrenCount === 1) {
            return react_1.default.createElement(react_1.default.Fragment, null, children);
        }
        return renderAntd();
    }
    /**
     * 渲染移动端
     */
    function renderMobile() {
        return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.Children.map(children, function (child) { return (react_1.default.createElement("div", { className: "section-row-mb" }, child)); })));
    }
    /**
     * 渲染超链
     */
    function renderLinks() {
        var links = props.links;
        if (!links) {
            return null;
        }
        return (react_1.default.createElement(react_1.default.Fragment, null, links.map(function (l, index) { return (react_1.default.createElement(Link_1.default, __assign({ key: "section-link-".concat(index) }, l))); })));
    }
    /**
     * 渲染副标题部分
     */
    function renderSubTitle() {
        var desc = props.desc, links = props.links;
        if (!desc && !links) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "title-sub" },
            desc && react_1.default.createElement("span", { className: "title-desc" }, desc),
            renderLinks()));
    }
    /**
     * 渲染主标题部分
     */
    function renderTitle() {
        var title = props.title;
        if (!title) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "section-title" },
            react_1.default.createElement("span", { className: "title-h1" }, title),
            renderSubTitle()));
    }
    return (react_1.default.createElement("section", { ref: ref, style: style, className: (0, classnames_1.default)("".concat(classPrefix, "-section"), className) },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('section-main', "section-col-".concat(col)) },
            renderTitle(),
            Number(size === null || size === void 0 ? void 0 : size.width) <= mobileWidth ? renderMobile() : renderPC())));
};
Section.CombineRow = CombineRow;
CombineRow.displayName = 'CombineRow';
Section.displayName = 'Section';
exports.default = Section;
//# sourceMappingURL=Section.js.map